export var theme = {
    container: {
        marginBottom: '32px',
        '& .MuiAccordionDetails-root': {
            overflow: 'hidden',
        },
        '& .MuiCollapse-root': {
            overflow: 'hidden',
        },
    },
    contentContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        columnGap: '16px',
    },
};
